//TODO: REMOVE CASEBOARD CONTEXT
import React, { createContext, SyntheticEvent, useState } from 'react';

import { EditCase } from '../services/Cases';
import { useRingCentralWidget } from '../services/RingCentral';
import { useSetRecoilState } from 'recoil';
import loadingState from '../stores/atoms/loadingAtom';
import useSnackbar from '../hooks/useSnackbar';

interface CaseBoardContextProps {
    useRingCentralWidget: any;
    switchTab: any;
    tab: number;
    isInboundCase: boolean;
    setIsInboundCase: any;
    editCase(caseId: string | number, body: any): any;
    editCaseQuery({ caseId, body }: { caseId: string | number; body: any }): any;
    openSnackbar: any;
    setShowLoading: any;
}

export const CaseBoardContext = createContext<CaseBoardContextProps | null>(
    null
) as React.Context<CaseBoardContextProps>;

export const CaseBoardProvider = ({ children }: { children: any }): JSX.Element => {
    const [tab, setTab] = useState(0);
    const [isInboundCase, setIsInboundCase] = useState(false);

    const switchTab = (event: SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const editCase = async (caseId: string | number, body: any) => {
        const editResult = await EditCase({ id: caseId, body });
        return editResult;
    };

    const editCaseQuery = async ({ caseId, body }: { caseId: string | number; body: any }) => {
        const editResult = await EditCase({ id: caseId, body });
        return editResult;
    };

    const setShowLoading = useSetRecoilState(loadingState);
    const { openSnackbar } = useSnackbar();

    return (
        <CaseBoardContext.Provider
            value={{
                tab,
                switchTab,
                useRingCentralWidget,
                isInboundCase,
                setIsInboundCase,
                editCase,
                editCaseQuery,
                openSnackbar,
                setShowLoading
            }}
        >
            {children}
        </CaseBoardContext.Provider>
    );
};
